import { render, staticRenderFns } from "./move-transfer-queue.vue?vue&type=template&id=90b4bb1e&scoped=true&"
import script from "./move-transfer-queue.vue?vue&type=script&lang=js&"
export * from "./move-transfer-queue.vue?vue&type=script&lang=js&"
import style0 from "./move-transfer-queue.vue?vue&type=style&index=0&id=90b4bb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4bb1e",
  null
  
)

export default component.exports